/**
 * src/data/tools.js — danh mục công cụ (đếm bằng SO_CONG_CU).
 *
 * Đây là bản seed TĨNH cho v0. Ở giai đoạn 2 nội dung này chuyển sang Firestore
 * collection `tools` (xem đặc tả mục 6) để thêm công cụ thứ 13 không phải build
 * lại app. Cấu trúc object giữ nguyên khi chuyển, nên không phải sửa giao diện.
 *
 * `status: 'READY'` mới hiện nút dùng được; còn lại hiện "đang xây".
 */

export const TOOLS = [
  {
    toolId: 'fund-match',
    slug: 'quy-phu-hop',
    order: 1,
    title: 'Quỹ nào phù hợp với bạn',
    blurb: 'Đối chiếu ngành, giai đoạn và địa bàn của bạn với khẩu vị của các quỹ đang hoạt động tại Việt Nam.',
    minutes: 4,
    stages: ['IDEA', 'PROTOTYPE', 'ANGEL', 'PRESEED'],
    topic: 'FUNDRAISING',
    status: 'READY',
  },
  {
    toolId: 'readiness-score',
    slug: 'diem-san-sang-goi-von',
    order: 2,
    title: 'Điểm sẵn sàng gọi vốn',
    blurb: 'Chấm hồ sơ trên năm trục để biết cần xử lý trục nào trước khi gặp nhà đầu tư.',
    minutes: 6,
    stages: ['ANGEL', 'PRESEED'],
    topic: 'FUNDRAISING',
    status: 'READY',
  },
  {
    toolId: 'raise-planner',
    slug: 'goi-bao-nhieu',
    order: 3,
    title: 'Gọi bao nhiêu và dùng vào việc gì',
    blurb: 'Từ mức đốt tiền hiện tại ra số tiền cần gọi để đủ 18 tháng, kèm phân bổ theo hạng mục.',
    minutes: 5,
    stages: ['ANGEL', 'PRESEED'],
    topic: 'FINANCE',
    status: 'READY',
  },
  {
    toolId: 'founder-equity-split',
    slug: 'chia-co-phan-dong-sang-lap',
    order: 4,
    title: 'Chia cổ phần đồng sáng lập và vesting',
    blurb: 'Một mốc tham chiếu minh bạch cho tỷ lệ chia, và soát bản chia của nhóm để chỉ ra rủi ro.',
    minutes: 6,
    stages: ['IDEA', 'PROTOTYPE', 'ANGEL', 'PRESEED'],
    topic: 'GOVERNANCE',
    status: 'READY',
  },
  {
    toolId: 'cap-table',
    slug: 'bang-co-phan-va-pha-loang',
    order: 5,
    title: 'Bảng cổ phần và pha loãng',
    blurb: 'Mô phỏng cơ cấu sở hữu qua nhiều vòng gọi vốn liên tiếp.',
    minutes: 5,
    stages: ['PRESEED', 'SEED'],
    topic: 'FUNDRAISING',
    status: 'READY',
  },
  {
    toolId: 'round-simulator',
    slug: 'mo-phong-vong-goi-von',
    order: 13,
    title: 'Mô phỏng vòng gọi vốn',
    blurb: 'Kéo thanh trượt định giá và số tiền gọi, thấy ngay phần sở hữu của bạn thay đổi qua từng vòng.',
    minutes: 2,
    stages: ['IDEA', 'PROTOTYPE', 'ANGEL', 'PRESEED', 'SEED'],
    topic: 'FUNDRAISING',
    status: 'READY',
  },
  {
    toolId: 'safe-convert',
    slug: 'safe-va-trai-phieu-chuyen-doi',
    order: 6,
    title: 'SAFE và trái phiếu chuyển đổi',
    blurb: 'Bạn đã ký SAFE 500 triệu, cap 8 tỷ. Vậy thực sự đã bán bao nhiêu phần trăm?',
    minutes: 6,
    stages: ['ANGEL', 'PRESEED'],
    topic: 'FUNDRAISING',
    status: 'READY',
  },
  {
    toolId: 'valuation-preseed',
    slug: 'dinh-gia-pre-seed',
    order: 7,
    title: 'Định giá vòng pre-seed',
    blurb: 'Khoảng định giá tham chiếu khi chưa có doanh thu, theo phương pháp chấm điểm chứ không theo bội số.',
    minutes: 5,
    stages: ['ANGEL', 'PRESEED'],
    topic: 'FINANCE',
    status: 'READY',
  },
  {
    toolId: 'valuation-revenue',
    slug: 'dinh-gia-co-doanh-thu',
    order: 7.5,
    title: 'Định giá khi đã có doanh thu',
    blurb: 'Bội số doanh thu hoặc EBITDA từ nhóm so sánh, đối chiếu với phương pháp VC, ra khoảng định giá trước vòng.',
    minutes: 7,
    stages: ['PRESEED', 'SEED'],
    topic: 'FINANCE',
    status: 'READY',
  },
  {
    toolId: 'market-sizing',
    slug: 'quy-mo-thi-truong',
    order: 8,
    title: 'Quy mô thị trường',
    blurb: 'Dựng TAM, SAM, SOM từ chính giả định của bạn, theo hướng bottom-up.',
    minutes: 5,
    stages: ['IDEA', 'PROTOTYPE', 'ANGEL', 'PRESEED'],
    topic: 'MARKET',
    status: 'READY',
  },
  {
    toolId: 'unit-economics-check',
    slug: 'kiem-tra-gia-dinh-kinh-te-don-vi',
    order: 9,
    title: 'Kiểm tra giả định kinh tế đơn vị',
    blurb: 'Chưa cần dữ liệu thật. Soát xem giả định về giá, chi phí và tỷ lệ giữ chân có vô lý không.',
    minutes: 4,
    stages: ['PROTOTYPE', 'ANGEL', 'PRESEED'],
    topic: 'FINANCE',
    status: 'READY',
  },
  {
    toolId: 'growth-metrics',
    slug: 'chi-so-tang-truong',
    order: 9.5,
    title: 'Chỉ số tăng trưởng',
    blurb: 'Từ doanh thu từng tháng ra tốc độ tăng, độ đều, doanh thu năm và tỷ lệ khách rời đi, đúng những số nhà đầu tư sẽ hỏi.',
    minutes: 5,
    stages: ['PRESEED', 'SEED'],
    topic: 'FINANCE',
    status: 'READY',
  },
  {
    toolId: 'runway',
    slug: 'tinh-runway',
    order: 10,
    title: 'Runway và mức đốt tiền',
    blurb: 'Số tháng còn hoạt động từ tiền mặt và chi phí thực tế, kèm kịch bản thận trọng.',
    minutes: 3,
    stages: ['PROTOTYPE', 'ANGEL', 'PRESEED', 'SEED'],
    topic: 'FINANCE',
    status: 'READY',
  },
  {
    toolId: 'pitch-deck',
    slug: 'pitch-deck-10-slide',
    order: 11,
    title: 'Pitch deck 10 slide',
    blurb: 'Khung 10 slide cho vòng đầu tiên, điền tới đâu chấm tới đó.',
    minutes: 8,
    stages: ['ANGEL', 'PRESEED'],
    topic: 'FUNDRAISING',
    status: 'READY',
  },
  {
    toolId: 'term-sheet',
    slug: 'doc-term-sheet',
    order: 14,
    title: 'Đọc term sheet bằng con số',
    blurb: 'Bán công ty ở mức nào thì bạn thực nhận bao nhiêu, và các điều khoản nào cần hỏi lại trước khi ký.',
    minutes: 8,
    stages: ['ANGEL', 'PRESEED', 'SEED'],
    topic: 'FUNDRAISING',
    status: 'READY',
  },
  {
    toolId: 'legal-checklist',
    slug: 'ho-so-phap-ly-khoi-nghiep',
    order: 12,
    title: 'Hồ sơ pháp lý khởi nghiệp',
    blurb: 'Loại hình doanh nghiệp, điều lệ, thoả thuận vesting, chuyển giao sở hữu trí tuệ: thiếu gì và làm trước cái nào.',
    minutes: 6,
    stages: ['IDEA', 'PROTOTYPE', 'ANGEL', 'PRESEED'],
    topic: 'LEGAL',
    status: 'READY',
  },
];

export const TOPIC_LABELS = {
  FUNDRAISING: 'Gọi vốn',
  FINANCE: 'Tài chính',
  MARKET: 'Thị trường',
  GOVERNANCE: 'Quản trị',
  LEGAL: 'Pháp lý',
};

export const STAGE_LABELS = {
  IDEA: 'Ý tưởng',
  PROTOTYPE: 'Nguyên mẫu',
  ANGEL: 'Angel',
  PRESEED: 'Pre-seed',
  SEED: 'Seed',
};

/**
 * Số công cụ đang dùng được. Mọi chỗ nói "N công cụ" phải lấy từ đây thay vì
 * viết cứng — thêm công cụ thứ 14 mà quên sửa chữ trên trang chủ là lỗi không
 * ai phát hiện cho tới khi có người đếm.
 */
export const SO_CONG_CU = TOOLS.filter((t) => t.status === 'READY').length;

export function toolBySlug(slug) {
  return TOOLS.find((t) => t.slug === slug) || null;
}
